"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordeonButton = void 0;
const base_component_1 = require("../base-component");
const key_1 = require("../../utils/key");
const utils_1 = require("../../utils/utils");
const ACCORDEON_SELECTOR = 'accordeon-component';
class AccordeonButton extends base_component_1.BaseComponent {
    mountComponent() {
        this.addListener(this, 'click', this.handleButtonClick);
        this.addListener(this, 'keydown', this.handleKeyDown);
    }
    handleButtonClick = (event) => {
        event.preventDefault();
        this.toggle();
    };
    handleKeyDown = (event) => {
        if ((0, key_1.isEnterKey)(event)) {
            event.preventDefault();
            this.toggle();
        }
    };
    toggle() {
        const accordeon = (0, utils_1.$elParent)(ACCORDEON_SELECTOR, this);
        accordeon?.toggle();
    }
}
exports.AccordeonButton = AccordeonButton;
